$(document).ready(function(){
    $('.js-icon').click(function(){
        $(this).toggleClass('open');
    });
});
